import {useTranslation} from "react-i18next";
import {IGpsrQuestion} from "../types/gpsr-questions";

export const useQuestionsList = () => {
    const {t} = useTranslation()

    const questionsList: IGpsrQuestion[] = [
        { // Topic 1
            topic: t('questions:topic1.title'),
            topicID: "t1",
            questions: [
                { // Topic 1 Question 1
                    title: t('questions:topic1.question1.title'),
                    questionID: "t1q1",
                    points: [
                        {
                            point: t('questions:topic1.question1.point1'),
                            pointID: "t1q1p1",
                            input: "",
                            files: [],
                            example: null
                        },
                        {
                            point: t('questions:topic1.question1.point2'),
                            pointID: "t1q1p2",
                            input: "",
                            files: [],
                            example: null
                        }
                    ]
                },
                { // Topic 1 Question 2
                    title: t('questions:topic1.question2.title'),
                    questionID: "t1q2",
                    points: [
                        {
                            point: t('questions:topic1.question2.point1'),
                            pointID: "t1q2p1",
                            input: "",
                            files: [],
                            example: null
                        },
                        {
                            point: t('questions:topic1.question2.point2'),
                            pointID: "t1q2p2",
                            input: "",
                            files: [],
                            example: null
                        },
                        {
                            point: t('questions:topic1.question2.point3'),
                            pointID: "t1q2p3",
                            input: "",
                            files: [],
                            example: null
                        },
                        {
                            point: t('questions:topic1.question2.point4'),
                            pointID: "t1q2p4",
                            input: "",
                            files: [],
                            example: null
                        },
                        {
                            point: t('questions:topic1.question2.point5'),
                            pointID: "t1q2p5",
                            input: "",
                            files: [],
                            example: null
                        },
                        {
                            point: t('questions:topic1.question2.point6'),
                            pointID: "t1q2p6",
                            input: "",
                            files: [],
                            example: null
                        }
                    ]
                },
                { // Topic 1 Question 3
                    title: t('questions:topic1.question3.title'),
                    questionID: "t1q3",
                    points: [
                        {
                            point: t('questions:topic1.question3.point1'),
                            pointID: "t1q3p1",
                            input: "",
                            files: [],
                            example: null
                        },
                        {
                            point: t('questions:topic1.question3.point2'),
                            pointID: "t1q3p2",
                            input: "",
                            files: [],
                            example: null
                        },
                        {
                            point: t('questions:topic1.question3.point3'),
                            pointID: "t1q3p3",
                            input: "",
                            files: [],
                            example: null
                        }
                    ]
                },
                { // Topic 1 Question 4
                    title: t('questions:topic1.question4.title'),
                    questionID: "t1q4",
                    points: [
                        {
                            point: t('questions:topic1.question4.point1'),
                            pointID: "t1q4p1",
                            input: "",
                            files: [],
                            example: null
                        },
                        {
                            point: t('questions:topic1.question4.point2'),
                            pointID: "t1q4p2",
                            input: "",
                            files: [],
                            example: null
                        },
                        {
                            point: t('questions:topic1.question4.point3'),
                            pointID: "t1q4p3",
                            input: "",
                            files: [],
                            example: null
                        },
                        {
                            point: t('questions:topic1.question4.point4'),
                            pointID: "t1q4p4",
                            input: "",
                            files: [],
                            example: null
                        }
                    ]
                },
                { // Topic 1 Question 5
                    title: t('questions:topic1.question5.title'),
                    questionID: "t1q5",
                    points: [
                        {
                            point: t('questions:topic1.question5.point1'),
                            pointID: "t1q5p1",
                            input: "",
                            files: [],
                            example: null
                        },
                        {
                            point: t('questions:topic1.question5.point2'),
                            pointID: "t1q5p2",
                            input: "",
                            files: [],
                            example: null
                        }
                    ]
                },
                { // Topic 1 Question 6
                    title: t('questions:topic1.question6.title'),
                    questionID: "t1q6",
                    points: [
                        {
                            point: t('questions:topic1.question6.point1'),
                            pointID: "t1q6p1",
                            input: "",
                            files: [],
                            example: null
                        },
                        {
                            point: t('questions:topic1.question6.point2'),
                            pointID: "t1q6p2",
                            input: "",
                            files: [],
                            example: null
                        }
                    ]
                },
                { // Topic 1 Question 7
                    title: t('questions:topic1.question7.title'),
                    questionID: "t1q7",
                    points: [
                        {
                            point: t('questions:topic1.question7.point1'),
                            pointID: "t1q7p1",
                            input: "",
                            files: [],
                            example: null
                        },
                        {
                            point: t('questions:topic1.question7.point2'),
                            pointID: "t1q7p2",
                            input: "",
                            files: [],
                            example: null
                        }
                    ]
                },
            ],
        },
        {   // Topic 2
            topic: t('questions:topic2.title'),
            topicID: "t2",
            questions: [
                { // Topic 2 Question 1
                    title: t('questions:topic2.question1.title'),
                    questionID: "t2q1",
                    points: [
                        {
                            point: t('questions:topic2.question1.point1.title'),
                            pointID: "t2q1p1",
                            input: "",
                            files: [],
                            example: {
                                text: t('questions:topic2.question1.point1.example.text'),
                                linkText: t('questions:topic2.question1.point1.example.link'),
                                linkUrl: "https://www.google.com"
                            }
                        }
                    ]
                },
                { // Topic 2 Question 2
                    title: t('questions:topic2.question2.title'),
                    questionID: "t2q2",
                    points: [
                        {
                            point: t('questions:topic2.question2.point1.title'),
                            pointID: "t2q2p1",
                            input: "",
                            files: [],
                            example: {
                                text: t('questions:topic2.question1.point1.example.text'),
                                linkText: t('questions:topic2.question1.point1.example.link'),
                                linkUrl: "https://www.google.com"
                            }
                        }
                    ]
                }
            ],
        },
        {   // Topic 3
            topic: t('questions:topic3.title'),
            topicID: "t3",
            questions: [
                { // Topic 3 Question 1
                    title: t('questions:topic3.question1.title'),
                    questionID: "t3q1",
                    points: [
                        {
                            point: t('questions:topic3.question1.point1.title'),
                            pointID: "t3q1p1",
                            input: "",
                            files: [],
                            example: {
                                text: t('questions:topic3.question1.point1.example.text'),
                                linkText: t('questions:topic3.question1.point1.example.link'),
                                linkUrl: "https://www.google.com"
                            }
                        }
                    ]
                },
                { // Topic 3 Question 2
                    title: t('questions:topic3.question2.title'),
                    questionID: "t3q2",
                    points: [
                        {
                            point: t('questions:topic3.question2.point1.title'),
                            pointID: "t3q2p1",
                            input: "",
                            files: [],
                            example: {
                                text: t('questions:topic3.question2.point1.example.text'),
                                linkText: t('questions:topic3.question2.point1.example.link'),
                                linkUrl: "https://www.google.com"
                            }
                        }
                    ]
                }
            ],
        },
        {   // Topic 4
            topic: t('questions:topic4.title'),
            topicID: "t4",
            questions: [
                { // Topic 4 Question 1
                    title: t('questions:topic4.question1.title'),
                    questionID: "t4q1",
                    points: [
                        {
                            point: t('questions:topic4.question1.point1.title'),
                            pointID: "t4q1p1",
                            input: "",
                            files: [],
                            example: {
                                text: t('questions:topic4.question1.point1.example.text'),
                                linkText: t('questions:topic4.question1.point1.example.link'),
                                linkUrl: "https://www.google.com"
                            }
                        }
                    ]
                },
                { // Topic 4 Question 2
                    title: t('questions:topic4.question2.title'),
                    questionID: "t4q2",
                    points: [
                        {
                            point: t('questions:topic4.question2.point1.title'),
                            pointID: "t4q2p1",
                            input: "",
                            files: [],
                            example: {
                                text: t('questions:topic4.question2.point1.example.text'),
                                linkText: t('questions:topic4.question2.point1.example.link'),
                                linkUrl: "https://www.google.com"
                            }
                        }
                    ]
                }
            ],
        },
        {   // Topic 5
            topic: t('questions:topic5.title'),
            topicID: "t5",
            questions: [
                { // Topic 5 Question 1
                    title: t('questions:topic5.question1.title'),
                    questionID: "t5q1",
                    points: [
                        {
                            point: t('questions:topic5.question1.point1.title'),
                            pointID: "t5q1p1",
                            input: "",
                            files: [],
                            example: {
                                text: t('questions:topic5.question1.point1.example.text'),
                                linkText: t('questions:topic5.question1.point1.example.link'),
                                linkUrl: "https://www.google.com"
                            }
                        }
                    ]
                },
                { // Topic 5 Question 2
                    title: t('questions:topic5.question2.title'),
                    questionID: "t5q2",
                    points: [
                        {
                            point: t('questions:topic5.question2.point1.title'),
                            pointID: "t5q2p1",
                            input: "",
                            files: [],
                            example: {
                                text: t('questions:topic5.question2.point1.example.text'),
                                linkText: t('questions:topic5.question2.point1.example.link'),
                                linkUrl: "https://www.google.com"
                            }
                        }
                    ]
                }
            ],
        },
        {   // Topic 6
            topic: t('questions:topic6.title'),
            topicID: "t6",
            questions: [
                { // Topic 6 Question 1
                    title: t('questions:topic6.question1.title'),
                    questionID: "t6q1",
                    points: [
                        {
                            point: t('questions:topic6.question1.point1.title'),
                            pointID: "t6q1p1",
                            input: "",
                            files: [],
                            example: {
                                text: t('questions:topic6.question1.point1.example.text'),
                                linkText: t('questions:topic6.question1.point1.example.link'),
                                linkUrl: "https://www.google.com"
                            }
                        }
                    ]
                },
                { // Topic 6 Question 2
                    title: t('questions:topic6.question2.title'),
                    questionID: "t6q2",
                    points: [
                        {
                            point: t('questions:topic6.question2.point1.title'),
                            pointID: "t6q2p1",
                            input: "",
                            files: [],
                            example: {
                                text: t('questions:topic6.question2.point1.example.text'),
                                linkText: t('questions:topic6.question2.point1.example.link'),
                                linkUrl: "https://www.google.com"
                            }
                        }
                    ]
                }
            ],
        },
        {   // Topic 7
            topic: t('questions:topic7.title'),
            topicID: "t7",
            questions: [
                { // Topic 7 Question 1
                    title: t('questions:topic7.question1.title'),
                    questionID: "t7q1",
                    points: [
                        {
                            point: t('questions:topic7.question1.point1.title'),
                            pointID: "t7q1p1",
                            input: "",
                            files: [],
                            example: {
                                text: t('questions:topic7.question1.point1.example.text'),
                                linkText: t('questions:topic7.question1.point1.example.link'),
                                linkUrl: "https://www.google.com"
                            }
                        }
                    ]
                }
            ],
        },
        {   // Topic 8
            topic: t('questions:topic8.title'),
            topicID: "t8",
            questions: [
                { // Topic 8 Question 1
                    title: t('questions:topic8.question1.title'),
                    questionID: "t8q1",
                    points: [
                        {
                            point: t('questions:topic8.question1.point1.title'),
                            pointID: "t8q1p1",
                            input: "",
                            files: [],
                            example: {
                                text: t('questions:topic8.question1.point1.example.text'),
                                linkText: t('questions:topic8.question1.point1.example.link'),
                                linkUrl: "https://www.google.com"
                            }
                        }
                    ]
                },
                { // Topic 8 Question 2
                    title: t('questions:topic8.question2.title'),
                    questionID: "t8q2",
                    points: [
                        {
                            point: t('questions:topic8.question2.point1.title'),
                            pointID: "t8q2p1",
                            input: "",
                            files: [],
                            example: {
                                text: t('questions:topic8.question2.point1.example.text'),
                                linkText: t('questions:topic8.question2.point1.example.link'),
                                linkUrl: "https://www.google.com"
                            }
                        }
                    ]
                }
            ],
        },
        {   // Topic 9
            topic: t('questions:topic9.title'),
            topicID: "t9",
            questions: [
                { // Topic 9 Question 1
                    title: t('questions:topic9.question1.title'),
                    questionID: "t9q1",
                    points: [
                        {
                            point: t('questions:topic9.question1.point1.title'),
                            pointID: "t9q1p1",
                            input: "",
                            files: [],
                            example: {
                                text: t('questions:topic9.question1.point1.example.text'),
                                linkText: t('questions:topic9.question1.point1.example.link'),
                                linkUrl: "https://www.google.com"
                            }
                        }
                    ]
                }
            ],
        },
        {   // Topic 10
            topic: t('questions:topic10.title'),
            topicID: "t10",
            questions: [
                { // Topic 10 Question 1
                    title: t('questions:topic10.question1.title'),
                    questionID: "t10q1",
                    points: [
                        {
                            point: t('questions:topic10.question1.point1.title'),
                            pointID: "t10q1p1",
                            input: "",
                            files: [],
                            example: {
                                text: t('questions:topic10.question1.point1.example.text'),
                                linkText: t('questions:topic10.question1.point1.example.link'),
                                linkUrl: "https://www.google.com"
                            }
                        }
                    ]
                }
            ],
        },
        {   // Topic 11
            topic: t('questions:topic11.title'),
            topicID: "t11",
            questions: [
                { // Topic 11 Question 1
                    title: t('questions:topic11.question1.title'),
                    questionID: "t11q1",
                    points: [
                        {
                            point: t('questions:topic11.question1.point1.title'),
                            pointID: "t11q1p1",
                            input: "",
                            files: [],
                            example: {
                                text: t('questions:topic11.question1.point1.example.text'),
                                linkText: t('questions:topic11.question1.point1.example.link'),
                                linkUrl: "https://www.google.com"
                            }
                        }
                    ]
                }
            ],
        },
    ]

    return {questionsList}
}